import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl } from '@material-ui/core';
import MuiPhoneNumber from 'material-ui-phone-number';
import useReactHookFormStyles from '../../../custom-components/form-components/ReactHookForm.styles';

const PhoneInput = ({ name, props: { label, rules, type, fieldOpts, required, defaultCountry, ...rest } }) => {
    const classes = useReactHookFormStyles();
    const {
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <FormControl className={type !== 'hidden' && classes.formController}>
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({ field }) => (
                    <MuiPhoneNumber
                        defaultCountry={defaultCountry}
                        disableAreaCodes
                        InputLabelProps={{ shrink: true }}
                        {...field}
                        {...fieldOpts}
                        required={required}
                        label={label}
                        {...rest}
                        error={!!errors[name]}
                        helperText={errors[name]?.message ?? ''}
                        // wrap
                    />
                )}
            />
        </FormControl>
    );
};

export default PhoneInput;
